import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ROUTES } from "@/constants/routes";
import { FullScreenLoader } from "@/components/organisms/FullScreenLoader";

/**
 * Envolve rotas de autenticação (Login/Cadastro/Recuperar Senha).
 * Usuário já logado é redirecionado direto para a Home.
 */
export function PublicRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <FullScreenLoader />;

  if (isAuthenticated) {
    return <Navigate to={ROUTES.home} replace />;
  }

  return <Outlet />;
}
